import Slider from 'react-slick'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'

import TypographyRebrand from 'src/components/atoms/TypographyRebrand/TypographyRebrand'
import { FeaturedPostsRebrandResult } from 'src/components/layouts/Page/SanityContentPage/types'
import { BlogPostCardRebrand } from 'src/components/molecules/BlogPostCardRebrand'

import { trpc } from 'src/utils/trpc'

const CAROUSEL_SETTINGS = {
  arrows: false,
  dots: true,
  infinite: false,
  speed: 400,
  slidesToShow: 1,
  slidesToScroll: 1,
  swipe: true,
  swipeToSlide: true
}

type FeaturedPostsSectionRebrandProps = Pick<
  FeaturedPostsRebrandResult,
  'heading'
> & {
  // Which posts to show (Sanity `featuredOn`). Defaults to content-page posts;
  // pass e.g. 'treeDetailPage' to reuse this section on the native-tree pages.
  featuredOn?: string
}

const FeaturedPostsSectionRebrand = ({
  heading,
  featuredOn = 'contentPages'
}: FeaturedPostsSectionRebrandProps) => {
  const { data } = trpc.useQuery([
    'sanity.getPosts',
    {
      category: 'all',
      year: 'all',
      limit: 3,
      featuredOn
    }
  ])

  const posts = data?.data ?? []

  if (posts.length === 0) return null

  return (
    <div className='container mx-auto px-4 lg:px-20'>
      {heading && (
        <div className='mb-4'>
          <TypographyRebrand variant='h4' color='forestDeep'>
            {heading}
          </TypographyRebrand>
        </div>
      )}

      <div className='hidden lg:grid lg:grid-cols-3 lg:gap-4'>
        {posts.map(post => (
          <BlogPostCardRebrand key={post._id} post={post} />
        ))}
      </div>

      <div className='lg:hidden pb-10'>
        <Slider {...CAROUSEL_SETTINGS}>
          {posts.map(post => (
            <div key={post._id} className='px-2'>
              <BlogPostCardRebrand post={post} />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  )
}

export default FeaturedPostsSectionRebrand
